module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-field"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-with-btn",
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.type,
      "readonly": ""
    },
    domProps: {
      "value": _vm.getPromoUrl
    },
    on: {
      "focus": _vm.select
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-flat btn-copy",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.copyPromoUrl()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/copy-icon.svg")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0e7ef96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/promoUrl.vue
// module id = 399
// module chunks = 0